/**
 * Brand selection.
 *
 * One place decides the palette. Components never reference a colour directly; they use the
 * semantic tokens in tokens.css, so a rebrand is a token block, not a sweep through the code.
 *
 * Order of precedence, most specific first:
 *   1. ?brand=codvo in the URL, for showing a stakeholder an alternative without a deploy
 *   2. VITE_BRAND at build time
 *   3. the default below
 */
export const BRANDS = ["shell", "codvo", "neutral"] as const;
export type Brand = (typeof BRANDS)[number];

const DEFAULT_BRAND: Brand = (import.meta.env.VITE_BRAND as Brand) || "shell";

export function resolveBrand(): Brand {
  const fromUrl = new URLSearchParams(window.location.search).get("brand");
  if (fromUrl && (BRANDS as readonly string[]).includes(fromUrl)) return fromUrl as Brand;
  const stored = localStorage.getItem("brand");
  if (stored && (BRANDS as readonly string[]).includes(stored)) return stored as Brand;
  return DEFAULT_BRAND;
}

export function applyBrand(brand: Brand): void {
  document.documentElement.setAttribute("data-brand", brand);
  localStorage.setItem("brand", brand);
}
